import React, { Fragment, useRef, useState, useEffect, useMemo } from "react"
import { Link } from "react-router-dom"
import {
    Button, Card, CardBody, CardSubtitle, CardTitle, Col, Container, Label, Row
} from "reactstrap"
import Shimmer from "react-shimmer-effect";

import { accessRole } from "../../../../helpers/access_role"
import Select from "../../../../helpers/ui/CustomSelect"
import TableActiveComponent from './Components/TablePrimaryComponent'


import DataTableBloc from './Blocs/DataTableBloc';
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'
import apiResponse from "../../../../services/apiResponse";


const statusPengajuan = [
    { value: '', label: 'Semua Status' },
    { value: 0, label: 'Menunggu Persetujuan Admin' },
    { value: 1, label: 'Pengajuan Disetujui' },
    { value: 2, label: 'Pengajuan Ditolak' },
]

const IndexView = ({uuid}) => {
    let datatableBloc = useMemo(() => new DataTableBloc(), []);
    const sourceRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState([]);


    const [activeTab, setactiveTab] = useState("1")    
    const [status, setStatus] = useState(null)
    const [filter, setFilter] = useState()
    const activeRef = useRef();
    const inactiveRef = useRef();

    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'))
    const peg_detail = !accessRole('approve') ? (userdata != null ? userdata : "") 
    : (employeeSeleted != null ? employeeSeleted : "")

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    // const reloadInactiveRef = () => activeRef.current.setTokenAPI()


    // const LoadingState = () => (
    //     <div
    //       style={{
    //         padding: "80px 0",
    //         display: "flex",
    //         flexDirection: "column",
    //         alignItems: "center",
    //         justifyContent: "center",
    //         textAlign: "center",
    //       }}
    //     >
    //       <Spinner color="primary" style={{ width: "4rem", height: "4rem" }} />
    //       <h5 className="mt-4 text-muted">Mengambil data...</h5>
    //     </div>
    //   );

    const handleButtonSearch = () => {
        // if (status) {
            setFilter({
                'status': status
            })
            setTimeout(() => {
                reloadActiveRef()
            }, 300);
        // }
    }

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }



    const  loadDetail = async (token) => {
        // if (!uuid) return; 
          const query = {
              uuid: userdata.employee_uuid,
          }
    
          await datatableBloc.fetchTotal(query, token)
      }
      
      useEffect(() => {
        // if (!uuid) return;
    
        if (sourceRef.current) {
          sourceRef.current.cancel();
        }
    
         // buat cancelToken baru
         const source = cancelToken();
         sourceRef.current = source;
     
         // load data baru
         loadDetail(source.token);
    
    
        // get data unit
        const subscription =  datatableBloc.totalChannel.subscribe((result) => {
          switch (result.status) {
            case apiResponse.INITIAL:
              setLoading(true);
              break;
            case apiResponse.COMPLETED:
              if (result.data.status) {
                let response = result.data.response;
                setDetail(response);
                setLoading(false);
              }
              break;
            case apiResponse.ERROR:
              setLoading(false);
              break;
            default:
              break;
          }
        });
    
        
    
        return () => {
          if (sourceRef.current) {
            sourceRef.current.cancel();
          }
          console.log("unmount");
          subscription.unsubscribe();
        };
      }, [uuid]);


    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">

                        <Card>
                            <CardBody>
                                <div className="float-end">
                                    <Button color="primary" onClick={()=>handleButtonSearch()}>Load Data</Button>
                                    &nbsp;&nbsp;
                                    { accessRole('create') &&
                                    <Link to="?createadmin">
                                        <Button color="primary" 
                                        // onClick={()=>reloadActiveRef()}
                                        >Tambah Pengajuan Angka Kredit</Button>
                                    </Link>
                                    }
                                </div>
                                <CardTitle>Daftar Pengajuan Angka Kredit</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Kelola Daftar Pengajuan Angka Kredit
                                </CardSubtitle>
                                <hr />
                                <Row className="mb-3">
                                    <Label className="col-md-3 col-form-label">
                                        Status Pengajuan Angka Kredit
                                    </Label>
                                    <Col md="3">
                                        <Select options={statusPengajuan} isAvForm={false} isClearable={true} 
                                        value={statusPengajuan.find(o => o.value === status)}
                                        onChange={opt => setStatus(opt ? opt.value : '')}
                                        />
                                    </Col>
                                </Row>
                                {/* <Row className="mb-3">
                                    <Label className="col-md-3 col-form-label">
                                        Total Angka Kredit
                                    </Label>
                                    <Col md="3">
                                    {loading ? (
                                         <Shimmer>
                                         <div
                                           style={{
                                             width: "100%",
                                             height: 30,
                                             marginBottom: "10px",
                                           }}
                                         ></div>
                                       </Shimmer>
                                    ): (

                                        <>{detail.total}</>

                                    )}

                                   
                                    </Col>
                                </Row> */}
                                <Row className="mb-3">
                                    <Col md="3"></Col>
                                    <Col md="10">
                                        <Button
                                            color="primary"
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                    </Col>
                                </Row>
                                <hr />
                                <TableActiveComponent ref={activeRef} 
                                // handleInactiveSuccess={reloadInactiveRef}
                                 filter={filter}/>
                            </CardBody>
                        </Card>
                        
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView